import { PizzaProduct } from './types';

export interface PizzaProductExtended extends PizzaProduct {
  videoBackground: string;
}

export const PIZZAS: PizzaProductExtended[] = [
  {
    id: 'magma',
    name: "The Magma",
    tagline: "Spicy Pepperoni",
    description: "Hand-stretched sourdough, Calabrian chili oil, double-smoked pepperoni, and a touch of honey on the crust.",
    price: "$24",
    color: "#E05A38", 
    ingredients: ["Pepperoni", "Chili Oil", "Honey", "Mozzarella"],
    image: "https://images.unsplash.com/photo-1513104890138-7c749659a591?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/384737151.sd.mp4?s=d74b62f43709b119159d332d7331f47d51963059&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: true,
    chefTip: "Drizzle our house habanero honey over the blistered crust edges before taking your first bite!",
    categories: ['spicy']
  },
  {
    id: 'verde',
    name: "Verde Vita",
    tagline: "Pesto & Arugula",
    description: "Our signature basil-walnut pesto base, bufala mozzarella, and fresh arugula harvested at dawn.",
    price: "$28",
    color: "#1A3C28",
    ingredients: ["Pesto", "Arugula", "Pine Nuts", "Bufala"],
    image: "https://images.unsplash.com/photo-1576458088443-04a19bb13da6?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/477439364.sd.mp4?s=d998d757d296245089f2a9d8c977114b30172559&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: false,
    chefTip: "Pair with a chilled Pinot Grigio to let the fresh basil-walnut aroma truly shine.",
    categories: ['vegetarian']
  },
  {
    id: 'truffle',
    name: "Truffle Noir",
    tagline: "Truffle & Mushroom",
    description: "Black truffle cream, wild forest mushrooms, and aged pecorino shavings on a charcoal-infused base.",
    price: "$34",
    color: "#1A1A1A", 
    ingredients: ["Truffle", "Mushrooms", "Pecorino", "Charcoal"],
    image: "https://images.unsplash.com/photo-1604382354936-07c5d9983bd3?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/517409405.sd.mp4?s=07693d22b6b06361a99540c111c19d7d130e525a&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: true,
    chefTip: "The activated charcoal crust provides a subtle earthiness that amplifies black truffle cream notes.",
    categories: ['vegetarian']
  },
  {
    id: 'burrata',
    name: "Burrata Cloud",
    tagline: "Burrata & Tomato",
    description: "Creamy whole burrata ball, slow-roasted cherry tomatoes, and aged balsamic glaze drizzle.",
    price: "$30",
    color: "#EFE9E1", 
    ingredients: ["Burrata", "Tomato", "Balsamic", "Basil"],
    image: "https://images.unsplash.com/photo-1595854341625-f33ee10dbf94?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/494248848.sd.mp4?s=91480c5e648f572111756570c91550c82270923e&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: true,
    chefTip: "Cut into the whole burrata center right when it arrives to spread cream evenly over every slice!",
    categories: ['vegetarian']
  },
  {
    id: 'diavola',
    name: "Diavola V2",
    tagline: "Nduja & Chili",
    description: "Nduja sausage, red onion, black olives, and fermented chili honey for a balanced heat.",
    price: "$26",
    color: "#6D0000", 
    ingredients: ["Nduja", "Chili Honey", "Red Onion", "Olives"],
    image: "https://images.unsplash.com/photo-1534308983496-4fabb1a015ee?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/384737229.sd.mp4?s=d0061e858079a49931086256f10c663a8323865c&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: false,
    chefTip: "Spiced with authentic Calabrian Nduja — ask for extra fermented chili honey if you crave intense heat.",
    categories: ['spicy']
  },
  {
    id: 'bianca',
    name: "Bianca Dust",
    tagline: "White Pie",
    description: "Garlic confit, roasted cauliflower, caramelized onions, and a dusting of pecorino.",
    price: "$22",
    color: "#F8F8F8", 
    ingredients: ["Garlic", "Onion", "White Sauce", "Cauliflower"],
    image: "https://images.unsplash.com/photo-1555072956-7758afb20e8f?auto=format&fit=crop&q=80&w=800",
    videoBackground: "https://player.vimeo.com/external/435674739.sd.mp4?s=94d4a82173163351239c878988636f78f9f7596a&profile_id=164&oauth2_token_id=57447761",
    isChefsPick: false,
    chefTip: "Slow-roasted garlic confit melts into the crust for a delicate savory sweetness.",
    categories: ['vegetarian', 'vegan']
  }
];

export const COLORS = {
  burntSienna: '#E05A38',
  deepBasil: '#1A3C28',
  creamVanilla: '#F2E9D8',
};